import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { DataProvider, useData } from './context/DataContext';

const AppWithLoading = () => {
  return <App />;
};

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = createRoot(rootElement);
root.render(
  <React.StrictMode>
    <DataProvider>
      <AppWithLoading />
    </DataProvider>
  </React.StrictMode>
);